import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import amazonIcon from "../../../assets/images/amazon-ads.png"
import { APIClient } from "../../../helpers/ApiHelper";

// target parametresi eklenmiş
export const findAllVeloxityAudience = createAsyncThunk(
    "findAllVeloxityAudience",
    async (target, thunkAPI) => { 
        try {
            const apiClient = new APIClient();

            const response = await apiClient.get(`/api/v1/management/audience/list?target=false`);
            return response.data;
        } catch (error) {
            return [];
        }
    }
);

export const veloxityFindAllAudience = createSlice({
    name: "veloxityFindAllAudience",
    initialState: {
        loading: false,
        payload: [],
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(findAllVeloxityAudience.pending, (state) => {
                state.loading = true;
                state.payload = [];
            })
            .addCase(findAllVeloxityAudience.fulfilled, (state, action) => {
                state.loading = false;
                state.payload = action.payload.map(item => ({
                    ...item,
                    revenue: 15300,
                    adsPhoto: amazonIcon,
                }))
            })
            .addCase(findAllVeloxityAudience.rejected, (state) => {
                state.loading = false;
            });
    },
});

export default veloxityFindAllAudience.reducer;
